export function formatWelcomeDate(isoDate) {
  if (!isoDate) return '';
  const [y, m, d] = isoDate.split('-').map(Number);
  if (!y || !m || !d) return isoDate;
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export const PLACEHOLDER_EDITIONS = [
  {
    isoDate: '2026-05-15',
    subjectLine: 'eVTOL certification paths narrow as OEMs race range proofs',
    introSummary:
      'Joby, Archer, and Beta push flight envelopes while FAA rulemaking on BVLOS and type certs accelerates.',
    articleCount: 8,
    categories: ['Unmanned', 'Manned'],
    heroImage: null,
  },
  {
    isoDate: '2026-05-14',
    subjectLine: 'Defense primes re-bid autonomy stacks for contested airspace',
    introSummary:
      'Anduril, Shield AI, and legacy primes compete for layered sense-and-avoid on attritable platforms.',
    articleCount: 6,
    categories: ['AI', 'Airspace'],
    heroImage: null,
  },
  {
    isoDate: '2026-05-13',
    subjectLine: 'AAM manufacturing capacity shifts to U.S. composites hubs',
    introSummary:
      'Tier-1 suppliers announce new filament-winding lines aimed at eVTOL primary structure.',
    articleCount: 7,
    categories: ['Manufacturing', 'Unmanned'],
    heroImage: null,
  },
  {
    isoDate: '2026-05-12',
    subjectLine: 'UAM corridors get state-level airspace carve-outs',
    introSummary:
      'Texas and Florida legislators advance bills that pre-empt local drone bans near vertiports.',
    articleCount: 5,
    categories: ['Airspace'],
    heroImage: null,
  },
  {
    isoDate: '2026-05-11',
    subjectLine: 'Battery swap networks pilot at regional airports',
    introSummary:
      'Operators test modular packs for 20-minute turnarounds on two-seat eVTOL demonstrators.',
    articleCount: 9,
    categories: ['Unmanned', 'Manufacturing'],
    heroImage: null,
  },
  {
    isoDate: '2026-05-10',
    subjectLine: 'Insurers price eVTOL hull risk with flight-data telematics',
    introSummary:
      'Underwriters demand ADS-B plus onboard health monitoring before binding Part 135 policies.',
    articleCount: 4,
    categories: ['Manned'],
    heroImage: null,
  },
];

/** Split rows into two columns for staggered marquee (col0, col1). */
export function splitEditionColumns(rows) {
  const col0 = [];
  const col1 = [];
  rows.forEach((row, i) => {
    if (i % 2 === 0) col0.push(row);
    else col1.push(row);
  });
  return { col0, col1 };
}
